import React, { useContext } from 'react';
import { Typography } from '@mui/material';
import { IRequirementRowPadding } from 'app/models/Placement/PlacementSummary';
import { useTranslation } from 'react-i18next';
import { ConfirmationsRow } from '../../TableComponents/Confirmations/ConfirmationsTable';
import { AddOnContext } from '../../../PlacementSummaryTab';
import {
  usePlacementSubmissionControl,
  useSubmissionPausePlacementToggleDisabled,
} from '@AMIEWEB/Candidate/CandidateProfile/SubmissionPaused/usePlacementSubmissionControl';
import { SubmissionPausedToggleSwitch } from '@AMIEWEB/Candidate/CandidateProfile/SubmissionPaused/SubmissionPausedToggleSwitch';

export const SubmissionPausedConfirmationsRow = ({ hasRequirements }: IRequirementRowPadding) => {
  const { t } = useTranslation();
  const { placementId } = useContext(AddOnContext);
  const { control, loading, savingAffiliationIds, updateSubmissionPause } = usePlacementSubmissionControl(placementId);
  const isToggleDisabledByPlacement = useSubmissionPausePlacementToggleDisabled();

  if (!control?.affiliationId) {
    return null;
  }

  const eventLabel = control.eventName?.trim() || t('candidate.submissionPaused.eventNameUnknown');

  return (
    <ConfirmationsRow
      id="placement-offer-confirmations-submission-paused"
      lastUpdatedBy={control.lastUpdatedByUserName ?? undefined}
      lastUpdatedDate={control.lastUpdated ?? undefined}
      loading={loading}
      hasOtherRequirements={hasRequirements}
      controlComponent={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Typography sx={{ width: 'max-content' }} component="span" variant="body1">
            {t('placement.profile.summary.offer.confirmations.submissionPausedForEvent', { eventName: eventLabel })}
          </Typography>
          <SubmissionPausedToggleSwitch
            size="small"
            isSubmissionPaused={!!control.isSubmissionPaused}
            checked={!!control.isSubmissionPaused}
            onChange={updateSubmissionPause}
            externallyDisabled={
              loading || savingAffiliationIds.includes(control.affiliationId) || isToggleDisabledByPlacement
            }
            inputProps={{
              'aria-label': t('candidate.submissionPaused.toggleLabel'),
            }}
          />
        </div>
      }
    />
  );
};
